export const createEntityMutation = (
    companyId: number, name: string, abbreviation: string, domains: string) =>
{
    return `mutation {
        createEntity(companyId: ${companyId}, name: "${name}", abbreviation: "${abbreviation}", domains: "${domains}") {
            entity {
                id
                name
            }
        }
    }
`
}
